import ReactDOM from "react-dom";
import { Fragment } from "react";
import styled from "styled-components";

const ModalWrap = styled.div`
  z-index: 3;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;

  max-width: 620px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  border-radius: 8px;
  background-color: #efefef;
  height: auto;
`;

const GrayBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 10000px;
  background: rgba(0, 0, 0, 0.75);
  z-index: 2;
`;

const Backdrop = (props) => {
    const content = <GrayBackdrop onClick={props.onClose} />;
    return ReactDOM.createPortal(
        content,
        document.getElementById("backdrop-hook")
    );
};

const ModalOverlay = (props) => {
    const content = <ModalWrap {...props}>{props.children}</ModalWrap>;
    return ReactDOM.createPortal(
        content,
        document.getElementById("modal-hook")
    );
};

export const Modal = (props) => {
    return props.showModal ? (
        <Fragment>
            <Backdrop onClose={props.onClose} />
            <ModalOverlay {...props} />
        </Fragment>
    ) : null;
};
